import {
  Button,
  Checkbox,
  Chip,
  CircularProgress,
  createTheme,
  Dialog,
  DialogTitle,
  Divider,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  makeStyles,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Theme,
  ThemeProvider,
  Tooltip,
  Typography,
  withStyles,
} from "@material-ui/core";
import * as React from "react";
import { useState } from "react";
import { SearchBar } from "src/components/sub-components/SearchBar";
import { primaryBlue, secondaryTextColor, white, } from "src/components/colors";
import { environment } from "src/environments/environment";
import * as _ from "underscore";
import { Alert, Pagination } from "@material-ui/lab";
import { CloseIconColor, ConfigureIcon, ContainedStar, ContainedStarNew, DownArrowFull, FilterIcon, ListIcon, MenuDots, OutlinedStar, OutlinedStarNew, Refresh, ReinstallIcon, UpArrowFull } from "src/components/Icons";
import OTAHistory from "src/components/sub-components/OTAHistory";
import {AddNewFirmWarePopup} from "../product-types/add-new-firmware/AddNewFirmWarePopup";
import axios from "axios";
import useStyles from "src/app/maintenance/assets/styles";
import Cookies from "js-cookie";
import { DropDown } from "../setup-senzmatica/step-3/components/DropDown";
import { DropDownRMOTA } from "../setup-senzmatica/step-3/components/DropDownRMOTA";
import { ConfirmPopup } from "src/components/sub-components/ConfirmPopup";
import { isVersionGreater,normalizeVersionStr } from "../utils";









function filterVersionsAbove(currentVersion, versionsArray) {
  const cur = normalizeVersionStr(currentVersion);
  if (!cur) return [];
  return (versionsArray || [])
    .map((v) => normalizeVersionStr(v))
    .filter((v) => v !== '' && isVersionGreater(v, cur));
}
function filterVersionsBelow(currentVersion, versionsArray) {
  const cur = normalizeVersionStr(currentVersion);
  if (!cur) return [];
  return (versionsArray || [])
    .map((v) => normalizeVersionStr(v))
    .filter((v) => v !== '' && isVersionGreater(cur, v));
}

function extractRawVersions(availableProductVersions) {
  if (!availableProductVersions) return [];
  return availableProductVersions
    .slice(1, -1)
    .split(',')
    .map((v) => v.trim())
    .map((v) => v.replace(/^\s*"|"\s*$|^\s*'|'\s*$/g, ''))
    .filter((v) => v !== '');
}

const extractParameterIds = (version) => {
  console.log(version.remoteConfigurations);
  if (!version||!version.remoteConfigurations) return [];

  return version.remoteConfigurations.map(p => p.parameterId)
  
};


function getDropdownOptions(ele, upgrade,allProductDetails) {
  const raw = extractRawVersions(ele && ele.product && ele.product.availableProductVersions);
  // Find the product by productId
     
      const product = allProductDetails.find(p => p.id === ele.product.productId);
      console.log("product",product)

      let versionsList = (product && product.versions) || [];
      console.log("versionsList",versionsList);
      
  if (upgrade) {
    const upper= filterVersionsAbove(ele && ele.product && ele.product.currentProductVersion, raw);

    const tagged=updateTags(upgrade,upper,ele && ele.product && ele.product.previousVersion, ele && ele.product && ele.product.currentProductVersion,versionsList);
    return tagged;
  }
  const lower = filterVersionsBelow(ele && ele.product && ele.product.currentProductVersion, raw);
  const tagged = updateTags(upgrade,lower, ele && ele.product && ele.product.previousVersion, ele && ele.product && ele.product.currentProductVersion,versionsList);
  console.log("tagged",tagged);
  return tagged;
}
function updateTags(upgrade,versionArray, previous, current,versionsList) {
  if (!Array.isArray(versionArray)) return [];
  const prev = normalizeVersionStr(previous);
  const cur = normalizeVersionStr(current);

  const normalized = versionArray.map((v) => normalizeVersionStr(v));
  let latestIndex = -1;
  if(upgrade){
    for (let i = 0; i < normalized.length; i++) {
      if (latestIndex === -1 || isVersionGreater(normalized[i], normalized[latestIndex])) {
        latestIndex = i;
      }
    }
  }
  const versionsForDevice=versionsList.filter(versionObj => normalized.includes(versionObj.versionNum)).filter(v=>v.binURL!=null); //only view versions which have binURLs
  return versionsForDevice.map((versionObj, i) => {
    let label=versionObj.versionNum;
    if (versionObj.versionNum === prev) label = `${label} (Previous)`;
    else if (versionObj.versionNum === cur) label = `${label} (Current)`;
    else if (upgrade&&i === latestIndex) label = `${label} (Latest)`;
    if(versionObj.majorVersionUpgrade&&versionObj.majorVersionUpgrade===true){
      label=label+"[major]";
    }

    return label;
    })
    
  
}
export function OTAManagerComponent(props) {
  const classes = localStyles();
  const style =  useStyles();
  const theme = createTheme({
      typography: {
        body1: {
          fontSize: '14px', 
          fontFamily:'poppins'
        },
      },
    });
  const userId = Cookies.get("USER_ID");
  const [viewDevice, setViewDevice] = useState(false);
  const [upgradeDevice, setUpgradeDevice] = useState(false);
  const [devices, setDevices] = useState([]);
  const [annexed, setAnnexed] = useState([]);
  const [allProductDetails, setAllProductDetails] = useState([]);
  const [filterProdTypes, setFilterProdTypes] = useState([]);
  const [filterVersions,setFilterVersions]=useState([]);
  const [filterStatus,setFilterStatus]=useState([]);


  const [constAnnexed, setConstAnnexed] = useState([]);
  const scrollRefs = React.useRef(null);
  const [max, setMax] = useState(5);
  const [favoriteDevices, setFavouriteDevices] = useState([]);
  const [filterFavouriteDevices, setFilterFavouriteDevices] = useState(false);
  const [selectVersions, setSelectVersions] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(8);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [searchProdType,setSearchProdType]=useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [open, setOpen] = useState(false);
  const [reqSuccess, setReqSuccess] = useState(true);
  //Filter sets
  const [productType, setProductType] = useState([]);
  const [status, setStatus] = useState([
    "All",
    "Updated",
    "Pending",
    "Failure",
  ]);

  const [availableVersions, setAvailableVersions] = useState([    
  ]);

  const [constAnnexedFiltered, setConstAnnexedFiltered] = useState([]);
  const uniqueClientDeviceCombinations = new Set();
  const [updateOpen, setUpdateOpen] = useState(false);
  const [selectedDevice, setSelectedDevice] = useState("");
  const [addNewOpen, setAddNewOpen] = useState(false);
  const [constProducts, setConstProducts] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [loadingScreen,setLoadingScreen]=useState(false);
  const [devicesToUpdate, setDevicesToUpdate] = useState([]);
  const [isUpgrade,setIsUpgrade]=useState(false);

  const [filterVisible, setFilterVisible] = useState(false);

  const [openPopup,setOpenPopup]=useState(false);
  const [confirmTitle,setConfirmTitle]=useState("Confirm");
  const [confirmInfo,setConfirmInfo]=useState("Are you sure?");
  const [popupType,setPopupType]=useState("");
  const [versionToReinstall,setVersionToReinstall]=useState({
    id:"",
    version:"",
    productId:""
  })


  const closeAddNew = () => {
    setAddNewOpen(false);
  };
  const closeUpdateDevice = () => {   
    setUpgradeDevice(false);
  }

  React.useEffect(() => {
    setPage(1);
  }, [search]);

  React.useEffect(() => {
    //getting states to default values
    setDevices([]);
    getAllDevices();
    getAllProducts();
  }, []);

/*
  const getProjects = () => {
    setProjects([]);
    axios.get(`${environment.host}/user/${userId}/project`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Cookies.get("ACCESS_TOKEN")}`,
      },
    })
      .then((response) => {
        if (response.data.content) {
          setProjects(response.data.content);
          setClients(["All", ..._.pluck(response.data.content, "name").sort()]);
        } else {
          setProjects([]);
        }
      })
      .catch((err) => {
        alert(err);
      });
    getFavourites(userId);
  };
  */
  React.useEffect(() => {
    if (devices.length > 0) {
      let deviceAnnex = [];
      let versionAnnex = [];
      let previousVersionAnnex = [];

      devices.forEach((device) => {
        if (device.otaRequestTopic) {

          const updatedDevice = { ...device };

          if (updatedDevice.product) {
            updatedDevice.product.majorVersionUpgrade = false;

            if (updatedDevice.product.currentProductVersion) {
              versionAnnex.push(updatedDevice.product.currentProductVersion);
            }

            if (updatedDevice.product.allProductVersionsOfDevice) {
              const versions = updatedDevice.product.allProductVersionsOfDevice
                .split(",")
                .map((num) => parseInt(num.trim(), 10));
              previousVersionAnnex.push(...versions);
            }
          }
          deviceAnnex.push(updatedDevice);
        }
      });

      setAnnexed(deviceAnnex);
      setConstAnnexed(deviceAnnex);

      setAvailableVersions(
        [ ...new Set(versionAnnex)].sort((a, b) => a - b)
      );

    }
  }, [devices]);

  const handleopenConfirm=(type,title,info)=>{
     setPopupType(type);
     setConfirmInfo(info);
     setConfirmTitle(title);
     setOpenPopup(true)
  }

  const closeConfirmPopup=()=>{
  setOpenPopup(false);
  }
  const handleConfirmPopup=()=>{
    if(popupType=="updateVersion"){
    upgradeDevices();
  }
  else if(popupType=="reinstall"){
    reinstallVersion(versionToReinstall.id,versionToReinstall.version,versionToReinstall.productId);
  }
    setOpenPopup(false);
  }


  const getAllDevices = () => {
    setLoadingScreen(true);
    axios.get(`${environment.host}/core/device/ota/upgradable`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Cookies.get("ACCESS_TOKEN")}`,
      },
    })
      .then((response) => {
        if (response.data.content) {
          setDevices(response.data.content);
          setLoadingScreen(false)
        } else {
          setDevices([]);
          setLoadingScreen(false)
        }
      })
      .catch((err) => {
        alert(err);
        setLoadingScreen(false)
      });
  };
  React.useEffect(() => {
    const uId = Cookies.get("USER_ID");
    axios.get(`${environment.host}/core/product/configDetails`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Cookies.get("ACCESS_TOKEN")}`,
      },
    })
      .then((response) => {
        let datas = response.data.content.productTypes[0];
        let otaUpgradableProducts = datas.filter(product => product.otaUpgradable);
        setAllProductDetails(otaUpgradableProducts);

        setProductType(_.pluck(otaUpgradableProducts, "productName").sort());
      })
      .catch((err) => {
        setProductType([]);
      });
    getFavourites(uId);
  }, []);

  const handleUpdateOpen = (props) => {
    setSelectedDevice(props);
    setUpdateOpen(true);
  };

  const [actionNames, setActionNames] = useState([]);
  var actions_name = [];
  React.useEffect(() => {
    axios.get(`${environment.host}/core/device`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Cookies.get("ACCESS_TOKEN")}`,
      },
    })
      .then((response) => {
        actions_name.push("ALL");
        const devices = response.data.content.content || response.data.content;
        devices.map((item) => {
          if (item.product !== undefined) {
            if (item.product.ActionBy !== undefined) {
              actions_name.push(item.product.ActionBy);
            }
          }
        });
      })
      .then(() => {
        const arr = [...new Set(actions_name)];
        setActionNames(arr);
      })
      .catch((err) => console.log(err));
  }, []);

  const getAllProducts = () => {
      axios.get(`${environment.host}/core/products?returnType=LIST`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Cookies.get("ACCESS_TOKEN")}`,
      },
    })
      .then((response) => {
        setConstProducts(response.data.content);
      })
      .catch((err) => {
        setConstProducts([]);
      });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(1);
  };
  const scrollSmoothHandler = (index) => () => {
    scrollRefs.current.scrollIntoViewIfNeeded();
  };
  const handleSelectAll = () => {
    const isSelectAll=!selectAll
    setSelectAll(isSelectAll);


    const updatedSelectVersions = isSelectAll
      ? 
       annexed.map((ele) => ({
        id: ele.id,
        version: ele.product.currentProductVersion,
        productId: ele.product.productId,
      })):[];
    setSelectVersions(updatedSelectVersions);
    setDevicesToUpdate(isSelectAll ? annexed : []);
  };
  const getFavourites = (id) => {
    axios.get(`${environment.host}/core/user/${id}/device/favourite`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Cookies.get("ACCESS_TOKEN")}`,
      },
    })
      .then((response) => {
        setFavouriteDevices(response.data.content);
      })
      .catch((error) => {
        setFavouriteDevices([]);
      });
  };
  const filterFavourite = () => {
    setFilterFavouriteDevices(!filterFavouriteDevices);
    if (filterFavouriteDevices === false) {
      setAnnexed(annexed.filter((obj) => favoriteDevices.includes(obj.id)));
      setPage(1);
    }
    if (filterFavouriteDevices === true) {
      getAllDevices();
    }
  };
  const addOrRemoveFavourite = (favourite, id) => {
    if (favourite === false) {
      const response=axios.put(`${environment.host}/core/user/${userId}/device-favourites/${id}?action=add`, id, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("ACCESS_TOKEN")}`,
        },
      })
        .then((response) => {
          getFavourites(userId);
        })
        .catch((error) => {
          getFavourites(userId);
        });
    }
    if (favourite === true) {
      axios.put(
        `${environment.host}/core/user/${userId}/device-favourites/${id}?action=remove`, id,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("ACCESS_TOKEN")}`,
          },
        }
      )
        .then((response) => {
          getFavourites(userId);
        })
        .catch((error) => {
          getFavourites(userId);
        });
    }
  };
  const viewSelectedDevices = () => {
    if (constAnnexedFiltered.length > 0 || selectVersions.length === 0) {
      setAnnexed(constAnnexed);
      setConstAnnexedFiltered([]);
      return;
    }
    const constAnnexedFiltered_ = constAnnexed.filter((el) => {
      return selectVersions.some((f) => {
        return f.id === el.id;
      });
    });
    setConstAnnexedFiltered(constAnnexedFiltered_);
    setAnnexed(constAnnexedFiltered_);
    setPage(1);

  };
  const upgradeDevices = () => { //or downgrade
    if (selectVersions.length > 0) {
      let finalArray = [];
      finalArray = selectVersions.map((e) => _.omit(e, "id"));
      axios.put(`${environment.host}/core/product/version/${Cookies.get("USER_ID")}/update`, finalArray, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("ACCESS_TOKEN")}`,
        },
      })
        .then((response) => {
          if (response.data.errorCode && response.data.errorCode.length > 0) {
            setReqSuccess(false);
            setOpen(true);
            setErrorMessage(response.data.message);
            setTimeout(() => {
              setOpen(false);
              setErrorMessage("");
            }, 5000);
          } else {
            setReqSuccess(true);
            setOpen(true);
            setTimeout(() => {
              setOpen(false);
            }, 5000);
              setUpgradeDevice(false);
              setSelectVersions([]);
              setDevicesToUpdate([]);
              setConstAnnexedFiltered([]);
              setViewDevice(false);
              getAllDevices();
              setFilterFavouriteDevices(false);
          }
        })
        .catch((err) => {
          console.log("err0,", err);
          setReqSuccess(false);
          setOpen(true);
          setTimeout(() => {
            setOpen(false);
          }, 5000);
        });
    }
  };

  const reinstallVersion=async(deviceId, versionToReinstall,productId)=>{
        let requestedVersion={
        productId: productId,
        version: {
          versionNum: versionToReinstall,
          devices: [deviceId],
          majorVersionUpgrade: false,
        },
        };
        
        await axios.put(`${environment.host}/core/product/version/${Cookies.get("USER_ID")}/update`, [requestedVersion], {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("ACCESS_TOKEN")}`,
        },
      })
        .then((response) => {
          getAllDevices();
          setFilterFavouriteDevices(false);

          if (response.data.errorCode && response.data.errorCode.length > 0) {
            setReqSuccess(false);
            setOpen(true);
            setErrorMessage(response.data.message);
            setTimeout(() => {
              setOpen(false);
              setErrorMessage("");
            }, 5000);
          } else {
            setReqSuccess(true);
            setOpen(true);
            setTimeout(() => {
              setOpen(false);
            }, 5000);
          }
        })
        .catch((err) => {
          getAllDevices();
          setReqSuccess(false);
          setFilterFavouriteDevices(false);
          setOpen(true);
          setTimeout(() => {
            setOpen(false);
          }, 5000);
        });
      

  }
  const selectDeviceToUpdate = (deviceUpdate) => {
    if(devicesToUpdate.filter(deviceAdded => deviceAdded.id === deviceUpdate.id).length === 0){
        setDevicesToUpdate((prevState) => [...prevState, deviceUpdate]);
      }
      else{
        setDevicesToUpdate(devicesToUpdate.filter(deviceAdded => deviceAdded.id !== deviceUpdate.id));
      }
    }
  
  const selectVersion = (id, version, productId,majorVersionUpgrade) => {
    let obj = {};
    if (
      selectVersions.filter(
        (e) => e["id"] === id && e["version"].versionNum === version
      ).length > 0
    ) {
      setSelectVersions(selectVersions.filter((e) => e["id"] !== id));
      return;
    }
    if (selectVersions.filter((e) => e["id"] === id).length > 0) {
      

      let a = selectVersions.filter((e) => e["id"] !== id);
      obj = {
        id: id,
        productId: productId,
        version: {
          versionNum: version,
          devices: [id],
          majorVersionUpgrade:majorVersionUpgrade ,
        },
      };
      setSelectVersions([...a, obj]);
      return;
    }
    obj = {
      id: id,
      productId: productId,
      version: {
        versionNum: version,
        devices: [id],
        majorVersionUpgrade: false,
      },
    };
    setSelectVersions((prevState) => [...prevState, obj]);
  }
const updateMajorVersionUpgrade = (id, upgrade) => {
  console.log(id)
  setSelectVersions((prevState) =>
    prevState.map((item) => {
      if (item.id !== id) return item;

      return {
        ...item,
        version: {
          ...item.version,
          majorVersionUpgrade: upgrade,
        },
      };
    })
  );
};


  const productTypeFilter = (prodType) => {
    let devicesSelectedProdType = [];
    if( filterProdTypes.length > 0 &&filterProdTypes.includes(prodType)){
      setFilterProdTypes(filterProdTypes.filter(item => item !== prodType));
         
    }
    else{
      setFilterProdTypes([...filterProdTypes, prodType]);
       
    }

   
  };
  const handleCloseFilter =()=>{
    setAnnexed(constAnnexed)
    handleFilterPop();
  }
  const handleFilterApply=()=>{
    setFilterVisible(false);
    let devicesfiltered=constAnnexed;
    if( filterProdTypes.length>0){
       devicesfiltered = constAnnexed.filter(
      (obj) => obj.product && obj.product.productType && filterProdTypes.includes( obj.product.productType)
    );
  }
    if(filterStatus.length>0 ){
      devicesfiltered = devicesfiltered.filter((obj) => {
        console.log("obj.product.currentVersionStatus",obj.product.currentVersionStatus);
        return obj.product &&  obj.product.currentVersionStatus && filterStatus.includes(obj.product.currentVersionStatus.toLowerCase())
    });
  }
       if(filterVersions.length>0 ){
      devicesfiltered = devicesfiltered.filter((obj) => {
         console.log("obj.product.current versions",obj.product.currentProductVersion);
        return obj.product &&  obj.product.currentProductVersion && filterVersions.includes(obj.product.currentProductVersion)
       })};
     setAnnexed(devicesfiltered);
    setPage(1);
    console.log("page set",annexed);
  }
  const statusFilter = (status) => {
    
   if(filterStatus.includes(status.toLowerCase())){
    setFilterStatus(filterStatus.filter(item => item !== status.toLowerCase()))}
  
  else {
    setFilterStatus([...filterStatus, status.toLowerCase()]);
  }
  }

  const versionFilter = (version) => {
     if(filterVersions.includes(version)){
    setFilterVersions(filterVersions.filter(item => item !== version))}
  
  else{
    setFilterVersions([...filterVersions, version]);
  }
  };


  const handleFilterPop = () => {  
    if(filterVisible){
      setFilterVisible(false);
      setSearchProdType("")
      setFilterProdTypes([])
      setFilterStatus([])
      setFilterVersions([])
      return;
    }
    setFilterVisible(true);
  }

  //   let obj = {};

  //   let updatedSelectVersions = [...selectVersions];
  //   const existingVersionIndex = updatedSelectVersions.findIndex(
  //     (e) => e.id === id
  //   );

  //   if (existingVersionIndex >= 0) {
  //     let a = updatedSelectVersions.filter((e) => e.id !== id);
  //     const existingVersion = updatedSelectVersions.find((e) => e.id === id);
  //     obj = {
  //       id: id,
  //       productId: existingVersion.productId,
  //       version: {
  //         versionNum: existingVersion.version.versionNum,
  //         devices: [id],
  //         majorVersionUpgrade: checked,
  //       },
  //     };
  //     updatedSelectVersions = [...a, obj];
  //   }

  //   setSelectVersions(updatedSelectVersions);
  // };
  const filteredDevices = annexed.filter((obj) => {
    return search === "" || obj.name.toLowerCase().includes(search.trim().toLowerCase());
  });
    const searchedProdTypes = productType.filter((prod) => {
    return searchProdType === "" || prod.toLowerCase().includes(searchProdType.trim().toLowerCase());
  });
  return (
    <ThemeProvider theme={theme}>
      <div className={`testing`}>
        <div className="page-heading">
          OTA Manager
        </div>
        <Grid container className={style.container}>
          <Grid container alignItems="center" justifyContent="space-between" style={{ position: "relative" }}>
            <Grid
              item
              xs={6}
              md={4}
              style={{display:"flex",flexDirection:"row", justifyContent: "flex-start",gap:"5px" }}
            >
              <SearchBar placeholder="Search Device Name" onChange={(e) => setSearch(e.target.value)} />
              <div style={{position:"relative"}}>
              <Button
                variant="outlined"
                className={style.filter}
                onClick={handleFilterPop}
              >
                <span
                  style={{
                    display: "flex",
                  }}
                >
                  <FilterIcon />
                </span>
                <span>Filter</span>
              </Button>
              {filterVisible && (
                <div className="filter-options" style={{ position: 'absolute', top: '50px', left:"0px" ,backgroundColor: '#fff', boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)', width: '400px', padding: '5px 5px', zIndex: 1000, marginBottom: "10px" }}>
                  <Grid item style={{ borderBottom: '1px solid #EDEDED', display: 'flex' }}>
                    <Typography style={{ color: '#1D283D', paddingLeft: '15px', fontFamily: 'Poppins', fontWeight: 'bold', marginBottom: "10px" }}> Filter</Typography>
                  </Grid>
                  <Grid item style={{ display: 'flex' }}>
                    <Typography style={{ color: '#1D283D', fontSize: "14px", paddingLeft: '15px', fontFamily: 'Poppins', fontWeight: 'bold', marginTop: "5px"}}> Product Type</Typography>
                  </Grid>

                  <Grid item style={{ maxHeight: '400px', overflowY: 'auto' }}>
                    <div style={{ padding: '5px' }}>
                      <SearchBar
                                  onChange={(e) => setSearchProdType(e.target.value)}
                                  InputProps={{
                                    style: {
                                      height: "30px",
                                    },
                                  }}
                                  placeholder="Search"
                                  value={searchProdType}
                              />
                    </div>
                    <div style={{ overflowY: "scroll", maxHeight: '150px' }}>
                      {searchedProdTypes.map((productType, index) => (
                        <div style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', marginLeft: '20px' }}>
                          <FormGroup style={{ margin: '0px' }}>
                            <FormControlLabel
                              label={productType}
                              className={style.filterItemText}
                              control={
                                <Checkbox
                                  size="small"
                                  className={style.radio}

                                  checked={filterProdTypes.includes(productType)}
                                  onChange={() => productTypeFilter(productType)}
                                />
                              }
                            />
                          </FormGroup>
                        </div>
                      ))}
                    </div>
                      <Grid item style={{ display: 'flex' }}>
                        <Typography style={{ color: '#1D283D', paddingLeft: '15px', fontSize: "14px", fontFamily: 'Poppins', fontWeight: 'bold',  marginTop: "10px" }}>Status </Typography>
                      </Grid>
                    <div style={{ marginTop: '10px' }}>
                      <div style={{ cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center', marginLeft: '20px' }}>
                        <FormGroup style={{ margin: '0px', flexDirection: 'row', gap: '10px' }}>
                          <Chip
                            className={`${style.greenChip} ${filterStatus.includes("updated") ? style.greenChipOutlined : ""}`}
                            label="Updated"
                            onClick={() => statusFilter("updated")}
                          />
                          <Chip
                            className={`${style.redChip} ${filterStatus.includes("failed") ? style.redChipOutlined : ""}`}
                            label="Failed"
                            onClick={() => statusFilter("failed")}
                          />

                          <Chip
                            className={`${style.yellowChip} ${filterStatus.includes("pending") ? style.yellowChipOutlined : ""}`}
                            label="Pending"
                            onClick={() => statusFilter("pending")}
                          />
                        </FormGroup>
                      </div>
                    </div>
                    <Grid item style={{ display: 'flex' }}>
                      <Typography style={{ color: '#1D283D', paddingLeft: '15px', fontFamily: 'Poppins',fontSize:"14px", fontWeight: 'bold', marginTop: "10px" }}>Version </Typography>
                    </Grid>
                    <div style={{ marginTop: '10px' }}>
                      <div style={{ cursor: 'pointer', display: 'flex', flexDirection: 'column', alignItems: 'center', marginLeft: '20px' }}>
                          <FormGroup style={{margin: '0px', overflowY: "scroll",flexDirection: 'row', gap: '10px' , maxHeight: '80px' }}>
                          {availableVersions.map((version, i) => (
                            <Chip
                              key={i}
                              className={style.greyChip}
                              label={version}
                              variant={filterVersions.includes(version) ? "outlined" : "default"}
                              onClick={() => versionFilter(version)}
                            />
                          ))}
                        </FormGroup>
                      </div>
                    </div>


                  </Grid>
                    <Grid container  justifyContent="flex-end"   style={{padding:"5px"}}>
                      <Grid item>
                        <Button className={style.buttonBackLight} onClick={handleCloseFilter}>Cancel</Button>
                      </Grid>
                      <Grid item>
                        <Button  className={style.customButton} onClick={() => handleFilterApply()}>Apply Filter</Button>
                      </Grid>
                  </Grid>
                </div>
              )}
              </div>
            </Grid>
            <Grid
              item
              xs={6}
              md={2}
              style={{ textAlign: "right",}}
            >
              <Button
                variant="contained"
                onClick={() => setAddNewOpen(true)}
                className={style.customButton}
              >
                Add Firmware
              </Button>
            </Grid>
          </Grid>
          <Grid
            container
            style={{
              marginTop: "20px",
            }}
          >
            <Grid
              item
              xs={5}
              md={5}
              style={{
                textAlign: "left",
                display: "flex",
                gap: "10px",
                alignItems: "center"
              }}
            >
              
              {selectAll || selectVersions.length > 0 ? (
                <>
                  <Typography>
                    {selectAll?filteredDevices.length:selectVersions.length} Devices Selected
                  </Typography>
                    <Button
                      onClick={() => {
                        setIsUpgrade(true);
                        setUpgradeDevice(true);

                      }}
                      size="small"
                      className={classes.outlinedButton}
                    >
                      <UpArrowFull/>
                      Upgrade Device
                    </Button>
                  
        
                    <Button
                      onClick={() => {
                      setIsUpgrade(false )
                      setUpgradeDevice(true);
                      }}
                      size="small"
                      className={`${classes.outlinedButton} ${classes.downgradeButton}`}
                    >
                      <DownArrowFull/>
                      Downgrade Device
                    </Button>
                
                </>
              ) : null}
            </Grid>
            <Grid
              item
              xs={5}
              md={5}

            >
              
            </Grid>
          </Grid>
          <Grid
            item
            xs={12}
            md={12}
            style={{ marginTop: "20px",}}
          >
            <TableContainer>
              <Table size="small">
                <TableHead>
                  <TableRow>
                      <TableCell
                        style={{
                          textAlign: "left",
                          borderBottomColor: "white",
                          borderTopColor: "white",
                          backgroundColor: "white",
                        }}
                      >

                    <Checkbox className={style.radio}
                    size="small"
                    onClick={() => handleSelectAll()}
                    checked={selectAll}
                  />
                  <Checkbox className={style.radio}
                    size="small"
                    onClick={() => filterFavourite()}
                    checked={filterFavouriteDevices}
                    icon={<OutlinedStarNew color="#868DAA" />}
                    checkedIcon={<ContainedStarNew  />}
                  />
                      </TableCell>

          
                    <TableCell
                      style={{
                        textAlign: "left",
                        borderBottomColor: "white",
                        borderTopColor: "white",
                        backgroundColor: "white",
                      }}
                    >
                      <div style={{ display: "inline-flex" }}>
                        <Typography className={style.tablehead}
                          display="inline"
                        >
                          Device Name
                        </Typography>

                      </div>
                    </TableCell>
                      <TableCell
                        style={{
                          textAlign: "left",
                          borderBottomColor: "white",
                          borderTopColor: "white",
                          backgroundColor: "white",
                          maxWidth:"200px"
                        }}
                      >
                        <div style={{ display: "inline-flex" }}>
                        <Typography className={style.tablehead}
                            display="inline"
                          >
                            Product Type
                          </Typography>

                        </div>
                      </TableCell>
                    <TableCell
                      style={{
                        textAlign: "center",
                        borderBottomColor: "white",
                        borderTopColor: "white",
                        backgroundColor: "white",
                      }}
                    >
                      <div style={{ display: "inline-flex" }}>
                      <Typography className={style.tablehead} 
                          display="inline"
                        >
                          Status
                        </Typography>
      
                      </div>
                    </TableCell>
                    <TableCell
                      style={{
                        textAlign: "center",
                        borderBottomColor: "white",
                        borderTopColor: "white",
                        backgroundColor: "white",
                      }}
                    >
                      <div style={{ display: "inline-flex" }}>
                        <Typography className={style.tablehead}
                          display="inline"
                        >
                          Current Version
                        </Typography>

                      </div>
                    </TableCell>
                      <TableCell
                        style={{
                          textAlign: "left",
                          borderBottomColor: "white",
                          borderTopColor: "white",
                          backgroundColor: "white",
                        }}
                      >
                        <div style={{ display: "inline-flex" }}>
                          <Typography className={style.tablehead}
                            display="inline"
                          >
                            Previous Versions
                          </Typography>

                        </div>
                      </TableCell>
                      <TableCell
                        style={{
                          textAlign: "left",
                          borderBottomColor: "white",
                          borderTopColor: "white",
                          backgroundColor: "white",
                        }}
                      >
                        <div style={{ display: "inline-flex" }}>
                          <Typography className={style.tablehead}
                          >
                            Actions
                          </Typography>

                        </div>
                      </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {annexed.length > 0 &&
                  filteredDevices
                      .slice((page-1) * rowsPerPage, page * rowsPerPage)
                      .map((ele, i) => {
                        const clientDeviceCombination = `${ele.client}_${ele.id}`;

                        // Check if the combination of client name and device name is unique
                        if (
                          !uniqueClientDeviceCombinations.has(
                            clientDeviceCombination
                          )
                        ) {
                          // Add the combination to the set
                          uniqueClientDeviceCombinations.add(
                            clientDeviceCombination
                          );
                          return (
                            <TableRow key={ele.id}
                              style={{
                                backgroundColor:
                                  i % 2 === 0 || i / 2 === 0
                                    ? "#F9F9F9"
                                    : "white"
                              }}>
                              <TableCell
                                style={{
                                  textAlign: "left",
                                  borderBottomColor: "white",
                                  borderTopColor: "white",
                                  display: "flex",
                                }}
                              >
                            

                                  
                                <Checkbox className={style.radio}
                                  size="small"
                                  checked={selectAll ||
                                    // devicesToUpdate.filter(
                                    //   (e) => e["id"] === ele.id
                                    // ).length > 0 ||
                                    devicesToUpdate.filter(
                                      (e) => e["id"] === ele.id
                                    ).length > 0
                                  }
                                  onClick={() => {
                                    if (selectAll) {
                                      return;
                                    }
                                    selectVersions.filter(
                                      (e) => e["id"] === ele.id
                                    ).length > 0
                                      ? setSelectVersions(
                                        selectVersions.filter(
                                          (e) => e["id"] !== ele.id
                                        )
                                      )
                                      : selectVersion(
                                        ele.id,
                                        ele.product.currentProductVersion,
                                        ele.product.productId,false
                                      );
                                  selectDeviceToUpdate(ele);
                                  }}
                                />
                                <Checkbox className={style.radio}
                                  size="small"
                                  onClick={() =>
                                    addOrRemoveFavourite(
                                      favoriteDevices !== undefined &&
                                      favoriteDevices.includes(ele.id),
                                      ele.id
                                    )
                                  }
                                  checked={
                                    favoriteDevices !== undefined &&
                                    favoriteDevices.includes(ele.id)
                                  }
                                  icon={<OutlinedStarNew color="#868DAA" />}
                                  checkedIcon={<ContainedStarNew />}
                                />
                              </TableCell>
                                {/* <TableCell
                                  style={{
                                    textAlign: "left",
                                    borderBottomColor: "white",
                                    borderTopColor: "white"
                                  }}
                                >
                                  <Typography className={classes.tableText}>
                                    {ele.product &&
                                      ele.product.Date &&
                                      ele.product.Date.toString().slice(0, 10)}
                                  </Typography>
                                </TableCell> */}
                              {/* <TableCell
                                style={{
                                  textAlign: "left",
                                  borderBottomColor: "white",
                                  paddingTop: "18px",
                                  paddingBottom: "18px",
                                  borderTopColor: "white"
                                }}
                              >
                                <Typography className={classes.tableText}>
                                  {ele.client}
                                </Typography>
                              </TableCell> */}
                              <TableCell
                                style={{
                                  textAlign: "left",
                                  borderBottomColor: "white",
                                  borderTopColor: "white",
                                  maxWidth:"200px",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                <Typography className={classes.tableText}>
                                  {ele.name}
                                </Typography>
                              </TableCell>
                                <TableCell
                                  style={{
                                    textAlign: "left",
                                    borderBottomColor: "white",
                                    borderTopColor: "white",
                                    maxWidth:"200px",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  <Typography className={classes.tableText}>
                                    {ele.product ? ele.product.productType : ""}
                                  </Typography>
                                </TableCell>
                              <TableCell
                                className={style.cellCenterAligned}
                              >
                                {ele.product &&
                                  ele.product.currentVersionStatus ===
                                  "UPDATED" && (
                                    <Chip
                                      className={style.greenChip}
                                      label="Updated"
                                    />
                                  )}
                                {ele.product &&
                                  ele.product.currentVersionStatus ===
                                  "PENDING" && (
                                    <Chip
                                      className={style.yellowChip}
                                      label="Pending"
                                    />
                                  )}
                                {ele.product &&
                                  ele.product.currentVersionStatus ===
                                  "FAILED" && (
                                    <Chip
                                      className={style.redChip}
                                      label="Failure"
                                    />
                                  )}
                              </TableCell>
                              <TableCell
                                className={style.cellCenterAligned}
                              >
                                <Typography className={classes.tableText}>
                                  {ele.product
                                    ?  (ele.product.currentProductVersion =="0.0.0"?
                                    "N/A":ele.product.currentProductVersion)
                                    : ""}
                                </Typography>
                              </TableCell>
                                <TableCell
                                  style={{
                                    textAlign: "left",
                                    borderBottomColor: "white",
                                    borderTopColor: "white",
                                    maxWidth:"200px",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  <Typography className={classes.tableText}>
                                    {ele.product
                                      ? ele.product.allProductVersionsOfDevice &&
                                      ele.product.allProductVersionsOfDevice
                                      : ""}
                                  </Typography>
                                </TableCell>
                              
                              <TableCell
                                style={{
                                  textAlign: "left",
                                  borderBottomColor: "white",
                                  borderTopColor: "white"
                                }}
                              >
                                <IconButton
                                  className={style.iconStyle}
                                  onClick={() => null}
                                  title="Version Upgrade"
                                >
                                  <ConfigureIcon />
                                </IconButton>
                                <IconButton
                                  className={style.iconStyle}
                                  onClick={() => {
                                    setVersionToReinstall({
                                      id:ele.id,
                                      version:ele.product.currentProductVersion,
                                      productId:ele.product.productId}
                                    );
                                    handleopenConfirm("reinstall","CONFIRMATION","Are you sure you wanted to reinstall the same version?");
                                  }}
                                  title="Reinstall Version"
                                >
                                  <ReinstallIcon />
                                </IconButton>
                                <IconButton
                                  className={style.iconStyle}
                                  onClick={() => {
                                    handleUpdateOpen({
                                      device: ele,
                                    });
                                  }}
                                  title="Upgrade History"
                                >
                                  <ListIcon />
                                </IconButton>
                                {updateOpen === true && (
                                  <OTAHistory
                                    device={selectedDevice}
                                    close={() => {
                                      setUpdateOpen(false);
                                    }}
                                  />
                                )}
                              </TableCell>
                            </TableRow>
                          );
                        }
                        return null;
                      })}
                </TableBody>
              </Table>
            </TableContainer>
            <Grid container justifyContent="center"  >
            {filteredDevices!== undefined && filteredDevices.length>rowsPerPage &&
          <Pagination className={style.pagination}
                      page={page}
                      onChange={handleChangePage}
                      count={filteredDevices !== undefined ? Math.ceil(filteredDevices.length / rowsPerPage) : 0}
                      shape="rounded"
                      defaultPage={1}
                      
                      />
            }
          </Grid>
          </Grid>
        </Grid>
        <Snackbar
          open={open}
          autoHideDuration={6000}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        >
          <Alert severity={reqSuccess === true ? "success" : "warning"}>
            <h3 style={{ textAlign: "left" }}>
              {reqSuccess === true ? "Success" : "Error"}
            </h3>
            {reqSuccess
              ? "Successfully Updated"
              : errorMessage.length > 0
                ? errorMessage
                : "Something Went Wrong"}
          </Alert>
        </Snackbar>
        {loadingScreen &&
          <div style={{
            position: 'fixed',
            left: 0,
            top: 0,
            backgroundColor: '#000000',
            opacity: 0.5,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
            width: '100vw',
            height: '100vh'
          }}>
            <CircularProgress size={80}/>
          </div>}

        <AddNewFirmWarePopup
          open={addNewOpen}
          onClose={() => closeAddNew()}
          refresh={() => getAllProducts()}
          products={constProducts}
        />

              <UpdateFirmwarePopup
          open={upgradeDevice}
          onClose={() => closeUpdateDevice()}
          refresh={() => getAllProducts()}
          products={constProducts}
          devicesToUpdate={devicesToUpdate}
          setSelectVersions={setSelectVersions}
          selectVersion={selectVersion}
          selectVersions={selectVersions}
          rowsPerPage={rowsPerPage}
          upgradeDevices={() => upgradeDevices()}
          allProductDetails={allProductDetails}
          upgrade={isUpgrade}
          handleConfirmOpen={handleopenConfirm}
          updateMajorVersionUpgrade={updateMajorVersionUpgrade}
        />
        <ConfirmPopup
        open={openPopup}
        closePopup={closeConfirmPopup}
        handleConfirm={handleConfirmPopup}
        title={confirmTitle}
        info={confirmInfo}
        handleDiscardConfirm={closeConfirmPopup}
        type={popupType}
        />
      </div>
    </ThemeProvider>
  );
}

export function UpdateFirmwarePopup(props) {
const [page, setPage] = useState(1);
const[majorVersionMap,setMajorVersionMap]=useState({
})
const[parameterMap,setParameterMap]=useState({});

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const classes = localStyles();
  const style =  useStyles();
 const uniqueClientDeviceCombinations = new Set();
  const closePopUp = () => {
    props.onClose();
  }
  const areParamsEqual = (map, deviceId, v1, v2) => {
    console.log(map)
  const deviceMap =
    map && map[deviceId] ? map[deviceId] : {};

  const a = deviceMap[v1] || [];
  const b = deviceMap[v2] || [];

  if (a.length !== b.length) return false;

  const setA = new Set(a);
  return b.every(function (p) {
    return setA.has(p);
  });
};

  React.useEffect(()=>{
    console.log("devicesToUpdate in popup:",props.devicesToUpdate);
    console.log("versions in popup:",props.selectVersions);
    const map = {};
  props.devicesToUpdate.forEach((d) => {
    map[d.id] = { major: false, disabled: true,isParamsDiffer:false };
  });
  setMajorVersionMap(map);

  const parameterMap={};
  props.devicesToUpdate.forEach((ele) => {
    const deviceId = ele.id;

    const product = props.allProductDetails.find(
      (p) => p.id === ele.product.productId
    );

    if (!product || !product.versions) return;

    parameterMap[deviceId] = {};

    product.versions.forEach((version) => {
      const versionNum = version.versionNum;

      const paramIds = extractParameterIds(version);

      parameterMap[deviceId][versionNum] = paramIds;
    });
  });
  setParameterMap(parameterMap)
    setPage(1);
  }

  ,[props.devicesToUpdate])

  return (
    <Dialog className={classes.dialogStyle} open={props.open}>
      <Grid container className={classes.popupHeader}>
        <Grid item xs={10} md={10}>
          <DialogTitle>
            <Typography >
          {props.upgrade ? "Upgrade" : "Downgrade"} Firmware
            </Typography>
          </DialogTitle>
        </Grid>
        <Grid item xs={2} md={2} style={{ textAlign: "right" }}>
          <IconButton
            onClick={() => {
              closePopUp();
            }}
          >
            <CloseIconColor />
          </IconButton>
        </Grid>
      </Grid>
      <Divider className={style.divider}/>
       <TableContainer className={classes.tableStyle}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell
                    style={{
                      textAlign: "left",
                      borderBottomColor: "white",
                      borderTopColor: "white",
                      backgroundColor: "white",
                    }}
                  >
                    <div style={{ display: "inline-flex" }}>
                      <Typography className={style.tablehead}
                        display="inline"
                      >
                        Device Name
                      </Typography>
                    </div>
                  </TableCell>
                    <TableCell
                      style={{
                        textAlign: "left",
                        borderBottomColor: "white",
                        borderTopColor: "white",
                        backgroundColor: "white",
                      }}
                    >
                      <div style={{ display: "inline-flex" }}>
                      <Typography className={style.tablehead}
                          display="inline"
                        >
                          Product Type
                        </Typography>
                      </div>
                    </TableCell>
                  <TableCell
                    style={{
                      textAlign: "center",
                      borderBottomColor: "white",
                      borderTopColor: "white",
                      backgroundColor: "white",
                    }}
                  >
                    <div style={{ display: "inline-flex" }}>
                    <Typography className={style.tablehead} 
                        display="inline"
                      >
                        Status
                      </Typography>
   
                    </div>
                  </TableCell>
                      <TableCell
                        style={{
                          textAlign: "center",
                          borderBottomColor: "white",
                          borderTopColor: "white",
                          backgroundColor: "white",
                        }}
                      >
                        <div style={{ display: "inline-flex" }}>
                        <Typography className={style.tablehead}
                            display="inline"
                          >
                            Update Versions
                          </Typography>
        
                        </div>
                      </TableCell>
                                            <TableCell
                        style={{
                          textAlign: "center",
                          borderBottomColor: "white",
                          borderTopColor: "white",
                          backgroundColor: "white",
                        }}
                      >
                        <div style={{ display: "inline-flex" }}>
                        <Typography className={style.tablehead}
                            display="inline"
                          >
                            Major Version Upgrade
                          </Typography>
        
                        </div>
                      </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                 {props.devicesToUpdate.length > 0 &&
                props.devicesToUpdate
                    .slice((page-1) * props.rowsPerPage, page * props.rowsPerPage)
                    .map((ele, i) => {
                      const clientDeviceCombination = `${ele.client}_${ele.id}`;

                      // Check if the combination of client name and device name is unique
                      if (
                        !uniqueClientDeviceCombinations.has(
                          clientDeviceCombination
                        )
                      ) {
                        // Add the combination to the set
                        uniqueClientDeviceCombinations.add(
                          clientDeviceCombination
                        );
                        return (
                          <TableRow key={ele.id}
                            style={{
                              backgroundColor:
                                i % 2 === 0 || i / 2 === 0
                                  ? "#F9F9F9"
                                  : "white"
                            }}>
                  
                            <TableCell
                              style={{
                                textAlign: "left",
                                borderBottomColor: "white",
                                borderTopColor: "white",
                                maxWidth: "150px",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                            >
                              <Typography className={classes.tableText}>
                                {ele.name}
                              </Typography>
                            </TableCell>
                              <TableCell
                                style={{
                                  textAlign: "left",
                                  borderBottomColor: "white",
                                  borderTopColor: "white",
                                  maxWidth: "150px",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                <Typography className={classes.tableText}>
                                  {ele.product ? ele.product.productType : ""}
                                </Typography>
                              </TableCell>
                            <TableCell
                              className={style.cellCenterAligned}
                            >
                              {ele.product &&
                                ele.product.currentVersionStatus ===
                                "UPDATED" && (
                                  <Chip
                                    className={style.greenChip}
                                    label="Updated"
                                  />
                                )}
                              {ele.product &&
                                ele.product.currentVersionStatus ===
                                "PENDING" && (
                                  <Chip
                                    className={style.yellowChip}
                                    label="Pending"
                                  />
                                )}
                              {ele.product &&
                                ele.product.currentVersionStatus ===
                                "FAILED" && (
                                  <Chip
                                    className={style.redChip}
                                    label="Failure"
                                  />
                                )}
                            </TableCell>
                                <TableCell className={style.cellCenterAligned}
                                >
                                  <div
                                    style={{
                                      display: "inline-flex",
                                      maxWidth: "200px",
                                    }}
                                  >
                                    <DropDownRMOTA
                                      options={getDropdownOptions(ele, props.upgrade,props.allProductDetails)}
                                      type="version"
                                       emptyTag={ele.product.currentProductVersion}
                                       onClick={(version) => {
                                        const isMajor=version.includes("[major]")?true:false;
                                        console.log("selected version:",version);
                                        const rawVersion = version
                                                .replace(/\s*\(Current\)/g, "")
                                                .replace(/\s*\(Previous\)/g, "")
                                                .replace(/\s*\(Latest\)/g, "")
                                                .replace(/\s*\[major\]/g, "");
                                        if (ele.product.currentProductVersion !== rawVersion) {
                                          props.selectVersion(
                                            ele.id,
                                            rawVersion,
                                            ele.product.productId,
                                            isMajor
                                          );
                                          let isParamsDiffer;
                                          if(!isMajor){
                                             isParamsDiffer=!areParamsEqual(parameterMap,ele.id,rawVersion,ele.product.currentProductVersion);
                                             console.log(isParamsDiffer)
                                          }
                                          setMajorVersionMap((prev) => ({
                                            ...prev,
                                            [ele.id]: {major:isMajor,disabled:isMajor||!isParamsDiffer,isParamsDiffer:isParamsDiffer}
                                          }));
                                        }}}

                                      value={(() => {
                                        const sel =
                                          props.selectVersions &&
                                          props.selectVersions.find((v) => v.id === ele.id) &&
                                          props.selectVersions.find((v) => v.id === ele.id).version &&
                                          props.selectVersions.find((v) => v.id === ele.id).version.versionNum;
                                        return sel
                                          ? sel === ele.product.currentProductVersion
                                            ? `${sel} (Current)`
                                            : sel
                                          : undefined;
                                      })()}

                                      isSingle={true}
                                    />
                                  </div>
                            </TableCell>
                            <TableCell className={style.cellCenterAligned}>
                              {(!!majorVersionMap[ele.id] && majorVersionMap[ele.id].isParamsDiffer) ? <Tooltip
                                title={"Parameters differ. Mark as major update?"}
                                arrow
                                placement="top"
                              >
                                <Checkbox
                                  className={style.radio}
                                  size="small"
                                  checked={!!majorVersionMap[ele.id] && majorVersionMap[ele.id].major}   // 👈 IMPORTANT
                                  disabled={!!majorVersionMap[ele.id] && majorVersionMap[ele.id].disabled}
                                  onClick={() => {
                                    const upgrade = !majorVersionMap[ele.id].major;
                                    setMajorVersionMap((prev) => ({
                                      ...prev,
                                      [ele.id]: {
                                        ...prev[ele.id],
                                        major: upgrade
                                      },
                                    }));

                                    props.updateMajorVersionUpgrade(ele.id, upgrade);
                                  }}
                                />
                              </Tooltip> : <Checkbox
                                className={style.radio}
                                size="small"
                                checked={!!majorVersionMap[ele.id] && majorVersionMap[ele.id].major}   // 👈 IMPORTANT
                                disabled={!!majorVersionMap[ele.id] && majorVersionMap[ele.id].disabled}
                                onClick={() => {
                                  const upgrade = !majorVersionMap[ele.id].major;
                                  setMajorVersionMap((prev) => ({
                                    ...prev,
                                    [ele.id]: {
                                      ...prev[ele.id],
                                      major: upgrade
                                    },
                                  }));

                                  props.updateMajorVersionUpgrade(ele.id, upgrade);
                                }}
                              />}

                            </TableCell>
                          </TableRow>
                        );
                      }
                      return null;
                    })}
          </TableBody>
        </Table>
      </TableContainer>:
      <Grid container justifyContent="center" style={{ marginBottom: "2px" }}>
        {props.devicesToUpdate !== undefined && props.devicesToUpdate.length > props.rowsPerPage &&
          <Pagination className={style.pagination}
                    page={page}
                    onChange={handleChangePage}
                    count={props.devicesToUpdate !== undefined ? Math.ceil(props.devicesToUpdate.length / props.rowsPerPage) : 0}
                    shape="rounded"
                    defaultPage={1}
                    
                    />
          }
        </Grid>
      <Grid container justifyContent="flex-end" style={{ padding: "5px" ,marginBottom:"2px"}}>

        <Grid
          item
        >
          <Button
            onClick={() => closePopUp()}
            className={style.buttonBackLight}
          >
            Cancel
          </Button>
        </Grid>
        <Grid
          item
        >
          <Button
            onClick={() => {
              const majorVersions=props.selectVersions.filter(v=>{return v.version.majorVersionUpgrade});
              console.log("majorVersions",majorVersions)
              if (majorVersions.length>0){
                props.handleConfirmOpen("updateVersion","Confirm","Some devices will be major version updated.Are you sure wanted continue?")
              }
              else{
              props.upgradeDevices()}}}
            className={style.customButton}
          >
            {props.upgrade ? "Upgrade " : "Downgrade "} 
          </Button>
        </Grid>

      </Grid>


    </Dialog>
  );
}
const localStyles = makeStyles((theme: Theme) => ({
  root: {
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  versionSelected: {
    backgroundColor: theme.palette.grey[50],
    border: `2px solid #2A7CED`,
    color: "#2A7CED",
    margin: "6",
  },
  version: {
    backgroundColor: theme.palette.grey[50],
    border: `1px solid #707170`,
    color: "#707170",
    margin: "6",
  },
  filter: {
    backgroundColor: white,
    color: secondaryTextColor,
    boxShadow: "none",
  },
  tableText: {
    fontSize: "14px",
    color: "#3C3C3C",
  },
  versionCircleText: {
    fontSize: "10px",
  },
  versionText: {
    fontSize: "14px",
    color: "#2A7CED",
  },

  versionChip: {
    backgroundColor: "#e6edf7",
    color: "#2a7ced",
    height: "20px",
    border: `1px solid #2A7CED`,
  },
  availableVersionChip: {
    backgroundColor: "#fff",
    color: "#707070",
    height: "20px",
  },
  viewDeviceButton: {
    width: "94px", 
    height: "24px",
    background: "#F2F2F2 0% 0% no-repeat padding-box",
    borderRadius: "19px",
    color: '#3C3C3C',
    fontSize: '10px',
    fontFamily:"poppins",
    border:"none",
    padding:"7px 15px",
    marginRight:"10px",
    textTransform:"none",
    whiteSpace:"nowrap",
    "&.active": {
      border: "1px solid #2A7CED",
      color: "#2A7CED",
      backgroundColor: "#fff",
    },},
    outlinedButton: {
    backgroundColor: white,
    padding:"5px",
    fontSize:"14px",
    color: "#2A7CED",
    border:"1px solid #2A7CED",
    boxShadow: "none",
    textTransform:"none",
    marginRight:"10px",
  },
    downgradeButton: {
    borderColor:"#000000",
    color:"#000000",
  },
  dialogStyle: {
    "& .MuiDialog-paperWidthSm": {
      maxWidth: "1000px !important",
      width: "100% !important",
      minHeight: "600px"
    }
  },
  popupHeader: {
    marginTop: "5px",
    marginBottom: "5px"
  },
  tableStyle: {
    marginTop: "0px"
  }
}));
const NewTooltip = withStyles({
  tooltip: {
    color: "black",
    backgroundColor: "white",
    boxShadow: "0px 3px 6px #00000029",
    padding: "10px",
  },
})(Tooltip);

